import { getAndroidApi, getAndroidEventLogger } from '../services/android/android.js';
import { getIOSApi, getIOSEventLogger } from '../services/ios/ios.js';
const providesAppApi = () => {
    return Boolean(getAndroidApi() || getIOSApi());
};
export const shouldTrackEventThroughApp = () => {
    return providesAppApi();
};
export const trackAppEvent = (event) => {
    const eventLogger = getAndroidEventLogger() || getIOSEventLogger();
    if (eventLogger) {
        eventLogger(event);
    }
};
//# sourceMappingURL=appTracking.js.map